import { z } from 'zod';
import { FlowTriggerFindAllOptionsSchema } from './findAllOptions.js';
import { FlowTriggersResponseSchema } from './schema.js';
export var FlowTriggerResponsePayload;
(function (FlowTriggerResponsePayload) {
    FlowTriggerResponsePayload["ParentTableOnly"] = "ParentTableOnly";
    FlowTriggerResponsePayload["ParentTableAndAllChildTables"] = "ParentTableAndAllChildTables";
})(FlowTriggerResponsePayload || (FlowTriggerResponsePayload = {}));
export const FlowTriggerListRoute = {
    method: 'get',
    fullPath: '/triggers',
    summary: 'List triggers',
    description: 'Lists the triggers that start flows, filterable by kind, flow, and organization. ' +
        'Each item summarizes one trigger: its kind, the flow it starts, the owning organization, ' +
        'and the kind-specific matching fields (for example the HL7 message type or the voice phone ' +
        'number). Results are scoped to the organizations the caller can access. Use it to discover ' +
        'what causes a flow to run, or to find every trigger of a given kind.',
    tags: ['Trigger'],
    query: FlowTriggerFindAllOptionsSchema.extend({
        payloadType: z
            .enum(FlowTriggerResponsePayload)
            .describe('Which fields to include per trigger. ParentTableAndAllChildTables (default) returns ' +
            'the common fields plus the kind-specific matching fields; ParentTableOnly returns ' +
            'only the common fields.')
            .optional()
            .default(FlowTriggerResponsePayload.ParentTableAndAllChildTables),
    }).strict(),
    response: FlowTriggersResponseSchema,
};
//# sourceMappingURL=routes.js.map